export const BackgroundColor = (() => {
	'use strict';

	let bgColorSections,
		nextColor,
		currentColor;

	function init() {
		bgColorSections = document.querySelectorAll('.pxblock--background-color');
		
		if (bgColorSections.length < 1) {
			return;
		}

		checkBgColor();
		window.addEventListener('scroll', () => {
			checkBgColor();
		});	
	}

	function checkBgColor() {
		bgColorSections.forEach(section => {
			if (section.getBoundingClientRect().top < window.innerHeight / 2) {
				nextColor = section.dataset.bgColor;
			}
		});

		if(nextColor && nextColor !== currentColor) {
			document.body.style.backgroundColor = nextColor;
			currentColor = nextColor;
		}		
	}

	return {
		init: init,
		name: 'background-color'
	};
})();
